import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

export default function useOperatorJobList() {
  // Use toast

  const refOperatorJobListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true },
    { key: 'jobId', sortable: true },
    { key: 'startDate', sortable: false },
    { key: 'endDate', sortable: false },
    { key: 'action', sortable: false },
  ]
  const perPage = ref(10)
  const totalOperatorJobs = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const row = ref([])
  const search = ref('')
  // const workcenters = ref([])

  const dataMeta = computed(() => {
    const localItemsCount = refOperatorJobListTable.value ? refOperatorJobListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * currentPage.value,
      of: totalOperatorJobs.value,
    }
  })

  const refetchData = () => {
    refOperatorJobListTable.value.refresh()
  }

  watch([currentPage, perPage, search], () => {
    refetchData()
  })

  function GetDataColectionOperatorJobs(id) {
    return new Promise((resolve, reject) => {
      store.dispatch('pamis-job/fetchOperatorJobs', id)
        .then(response => {
          if (response.data != null && response.data.length > 0) {
            row.value = response.data
            resolve(response.data)
            row.value = response.data
          } else {
            reject(response.data)
          }
        })
        .catch(() => {
        })
    })
  }
  function GetOperatorJobFieldsData() {
    store.dispatch('pamis-job/fetchJobFields')
  }
  async function GetData() {
    await GetOperatorJobFieldsData()
    await GetDataColectionOperatorJobs()
  }
  GetData()
  return {
    row,
    tableColumns,
    perPage,
    currentPage,
    search,
    totalOperatorJobs,
    dataMeta,
    perPageOptions,
    sortBy,
    isSortDirDesc,
    refOperatorJobListTable,
    refetchData,
  }
}
